import { useState } from "react";

import { useDiscoverContext } from "@/components/app/discover/discover-context";
import { DiscoverMainFilter } from "@/components/app/discover/discover-main-filter";
import { EmptyState } from "@/components/shared/empty-state";
import type { TokenMetadatum } from "@/graphql/codegen/graphql";
import { cn } from "@/utils/lib";

import { LaunchedTokenDetails } from "../launched-token-tab/launched-token-details";
import { UpcomingTokenDetails } from "../upcoming-tokens-tab/upcoming-token-details";
import type { useTokenMetrics } from "../use-token-metrics";
import { RecentTokenTile } from "./recent-token-tile";

export const RecentTokenTab = () => {
  const [selectedTokenMetrics, setSelectedTokenMetrics] = useState<ReturnType<
    typeof useTokenMetrics
  > | null>(null);

  const {
    creators: tokens,
    pinnedCreators,
    lazyLoadingMarkup,
    initialLoading,
  } = useDiscoverContext();

  const [isUpcomingToken, setIsUpcomingToken] = useState<boolean>(false);

  const hasResults = tokens.length > 0;

  return (
    <>
      <div className="mt-4 flex size-full border-y border-border-light px-2">
        <DiscoverMainFilter isTimePeriodDisabled />
      </div>
      <div className="relative flex h-full min-h-lvh flex-row">
        <div
          className={cn("flex w-full flex-col gap-6 p-6", {
            "border-r border-border-light sm:w-7/12": hasResults,
          })}
        >
          {!initialLoading &&
            [...pinnedCreators, ...tokens].map((token, index) => (
              <RecentTokenTile
                key={token.publicKeyBase58Check}
                index={index}
                {...{
                  selectedTokenMetrics,
                  setSelectedTokenMetrics,
                  token: token as TokenMetadatum,
                  isUpcomingToken,
                  setIsUpcomingToken,
                }}
              />
            ))}

          {lazyLoadingMarkup}
          {!initialLoading && tokens.length === 0 && (
            <div className="flex size-full items-center justify-center p-2 py-4">
              <EmptyState
                image="/assets/empty-31.png"
                title="No results."
                description="Try adjusting the filters."
              />
            </div>
          )}
        </div>
        {selectedTokenMetrics &&
          (isUpcomingToken ? (
            <UpcomingTokenDetails metrics={selectedTokenMetrics} />
          ) : (
            <LaunchedTokenDetails metrics={selectedTokenMetrics} />
          ))}
      </div>
    </>
  );
};
